import { useQuery } from "@tanstack/react-query";

import { api } from "@app/api/client";
import type { Overview } from "@app/api/types";

export function useOverview() {
  return useQuery({
    queryKey: ["overview"],
    queryFn: async (): Promise<Overview> => {
      const { data } = await api.get<Overview>("/admin/overview");
      return data;
    }
  });
}
